// import zhLocale from '@jdpop/element-ui/lib/locale/lang/zh-CN'
const zh = {
  w0: '充值记录',
  w1: '活动明细',
  w2: '发放记录',
  w3: '如有需要，可点击这里查看',
  w4: '权益中心介绍',
  w5: '权益中心新手指导',
  w6: '我的账户',
  w7: '发放权益',
  w8: '充值',
  w9: '余量',
  w10: '（含冻结）',
  w11: '张',
  w12: '冻结量',
  w13: '商家在已创建的营销活动中设置的发放给',
  w14: '端用户的权益总量',
  w15: '卡面额',
  w16: '元',
  w17: '爱奇艺会员',
  w18: '充值数量',
  w19: '预算费用',
  w20: '自动计算',
  w21: '支付完成后将无法退款，请仔细核对订单信息。',
  w22: '会员：',
  w23: '爱奇艺会员：',
  w24: '充值数量：',
  w25: '预算费用：',
  w26: '确认',
  w27: '取消',
  w28: '支付',
  w29: '返回',
  w30: '年卡',
  w31: '月卡',
  w32: '季卡',
  w33: '半年卡',
  w34: '充值数量需要为整数',
  w35: '请输入充值数量',
  w36: '流量包',
  w37: '流量数量',
  w38: '流量数量：',
  w39: '请输入流量数量',
  w40: '您当前所在位置',
  w41: '促销应用工具',
  w42: '权益中心',
  w43: '什么是权益中心',
  w44: '商家集中对各项虚拟资产进行充值、管理和使用的中心，虚拟资产可在各项营销工具',
  w45: '活动中发放给用户，包含充值记录、活动对应权益明细和发放记录的查看。',
  w46: '权益中心的优势',
  w47: '资产集中营',
  w48: '一站式管理',
  w49: '支持',
  w50: '营销场景',
  w51: '权益中心怎么玩',
  w52: '创建权益账户',
  w53: '签订服务协议',
  w54: '充值权益',
  w55: '创建营销活动',
  w56: '工具',
  w57: '官方工具',
  w58: '活动权益明细',
  w59: '下一页',
  w60: '权益中心都有哪些权益？',
  w61: '一期上线流量包和',
  w62: '卡两项权益，后续将上线爱奇艺会员卡、京东',
  w63: '会员等，如有其它权益需求，可在营销中心首页右侧的“意见反馈”中让我们知道。',
  w64: '权益中心中的权益和京豆、优惠券等使用区别是？',
  w65: '同时支持在各类营销活动中发放给用户，但只有在权益中心开通账户的权益可以查看充值记录、活动对应权益明细和发放记录。',
  w66: '如何使用权益？',
  w67: '完成权益账户的创建和充值后，在权益账户页面',
  w68: '发放权益，选择工具并在工具中创建营销活动，设置权益发放条件，由官方将权益免费发放至用户账户或在',
  w69: '我的活动中展示。',
  w70: '权益充值后有效期多久，是否支持退款？',
  w71: '各项权益的有效期不同，需在协议中分别查看，所有权益均不支持退款。',
  w72: '权益充值后如何开具发票？',
  w73: '在京麦服务市场进行下单支付时勾选开具发票，不支持后续线下开具。',
  w74: '更多操作流程介绍见帮助中心',
  w75: '我知道了',
  w76: '月份：',
  w77: '选择月',
  w78: '状态',
  w79: '下载',
  w80: '数量总计：',
  w81: '费用总计：',
  w82: '还没有充值过',
  w83: '点击充值按钮，获得自己的第一批资产吧',
  w84: '充值订单号',
  w85: '充值时间',
  w86: '面值',
  w87: '数量',
  w88: '充值订单金额',
  w89: '我们会人工跟进处理，请安心等待一下。',
  w90: '原因',
  w91: '还没有发放过',
  w92: '快去',
  w93: '创建自己的权益活动',
  w94: '吧',
  w95: '活动',
  w96: '活动时间',
  w97: '至',
  w98: '活动名称',
  w99: '活动状态',
  w100: '工具名称',
  w101: '发放数量',
  w102: '消耗费用',
  w103: '明细',
  w104: '这里会显示参加活动用户的领用记录',
  w105: '用户',
  w106: '领用时间',
  w107: '领用数量',
  w108: '全部',
  w109: '未上线',
  w110: '已结束',
  w111: '进行中',
  w112: '警告',
  w113: '请求超时',
  w114: '万元',
  w115: '成功',
  w116: '爱奇艺账户',
  w117: '权益列表',
  w118: '该余量不包含冻结余量',
  w119: '活动数',
  w120: '该活动数为在线活动数',
  w121: '创建账户',
  w122: '管理',
  w123: '卡帐户',
  w124: '流量帐户',
  w125: '账户',
  w126: '服务协议',
  w127: '我已仔细阅读并同意本协议',
  w128: '上一步',
  w129: '开通账户',
  w130: '开通成功',
  w131: '商家在已创建的营销活动中设置的发放给C端用户的权益总量',
  w132: '上一页',
  w133: '更多玩法>>',
  w134: '更多详情，点击查看>>',
  w135: '>>>点击前往',
  w136: '提示:此处最多充值9999元,1万元及以上',
  w137: '结算时间',
  w138: '发送数量',
  w139: '红包发放金额',
  w140: '提示',
  w141: '您当前登录的账户不是供应商pin或者没有授予京豆权限，请按照操作流程，给供应商pin授权后再登录使用京豆。',
  w142: '京豆操作流程，点击跳转>>>',
  w143: '您当前账号没有权限，请按照操作流程授权后再进行充值',
  w144: '充值操作流程，点击跳转>>>',
  w145: 'ISV第三方工具',
  w146: '查看详情',
  w147: '去使用',
  w148: '去购买',
  w149: '暂时无可用工具，敬请期待',

  w300: '视频答题红包活动',
  w301: '活动介绍',
  w302: '创建视频红包活动',
  w303: '活动',
  w304: '活动名称',
  w305: '活动时间',
  w306: '总金额',
  w307: '活动状态',
  w308: '操作',
  w309: '查看详细',
  w310: '开始时间',
  w311: '结束时间',
  w312: '红包有效期',
  w313: '红包档位设置',
  w314: '档位',
  w315: '档位成本',
  w316: '平均面额',
  w317: '移除',
  w318: '红包总成本',
  w319: '确定创建',
  w320: '取消',
  w321: '请输入时间',
  w322: '活动开始时间大于当前时间',
  w323: '间隔时间为',
  w324: '天',
  w325: '活动名称不能为空',
  w326: '活动名称在',
  w327: '个字内',
  w328: '过期时间不能为空',
  w329: '新增',
  w330: '活动状态',
}
export default Object.assign(zh, {})
